import Button from '@/components/Button'
import Title from '@/components/Title'
import { useModal } from '@/hooks'
import { copyIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import style from './styles/code.module.scss'

function updateClipboard (newClip): void {
  navigator.clipboard.writeText(newClip).then(function () {
    console.log('clipboard successfully set')
  }, function () {
    console.error('clipboard write failed')
  })
}

const ChampionshipCode = (): React.ReactElement => {
  const { modalProps } = useModal()
  const [success, setSuccess] = useState(false)
  const tourneyCode = modalProps?.tourneyCode ?? ''

  const handleCopy = (): void => {
    updateClipboard(tourneyCode)
    setSuccess(true)
    setTimeout(() => {
      setSuccess(false)
    }, 3000)
  }

  return (
    <div className={style.code}>
      <Title type='h2' theme='h3' className={style.code__title}>
        Код чемпионата
      </Title>

      <p className={style.code__text}>
        Для участия в чемпионате: скопируй код и введи его в игре.
      </p>

      <div className={style.code_flex}>
        <span className={style.code__codefield}>{tourneyCode}</span>

        <Button
          size='large'
          theme='secondary'
          wide
          highlight
          className={style.code__button}
          onClick={handleCopy}
          disabled={success}
        >
          <GxIcon src={copyIcon} slot='icon-left' />
          {success ? 'Скопировано' : 'Копировать'}
        </Button>
      </div>
    </div>
  )
}

export default ChampionshipCode
